"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/web.dom.iterable");
var _vue = _interopRequireDefault(require("vue"));
var _vuex = _interopRequireDefault(require("vuex"));
var _vuexPersistedstate = _interopRequireDefault(require("vuex-persistedstate"));
var _getters = _interopRequireDefault(require("./getters"));
_vue.default.use(_vuex.default);

// https://webpack.js.org/guides/dependency-management/#requirecontext
var modulesFiles = require.context('./modules', true, /\.js$/);

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
var moduleNameList = [];
var modules = modulesFiles.keys().reduce(function (modules, modulePath) {
  // set './app.js' => 'app'
  var moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  var value = modulesFiles(modulePath);
  // tagsView 在 vuex-persistedstate 存储报错
  // && moduleName !== 'tagsView'
  if (moduleName !== 'nocache') {
    moduleNameList.push(moduleName);
  }
  modules[moduleName] = value.default;
  return modules;
}, {});
var store = new _vuex.default.Store({
  plugins: [(0, _vuexPersistedstate.default)({
    paths: moduleNameList,
    storage: window.sessionStorage
  })],
  modules: modules,
  getters: _getters.default
});
var _default = exports.default = store;